import { Suspense } from 'react';
import { Overview } from '../overview';
import { useTemplateRoute } from './use-template-route';
import { TemplateArrival } from './template-arrival';
import { Center, Loader } from '@mantine/core';

export const TemplateRoute = () => {
  const { isReady, pendingArrival, clearArrival } = useTemplateRoute();

  if (!isReady) {
    return (
      <Center h="100vh">
        <Loader size="lg" />
      </Center>
    );
  }

  return (
    <>
      <Suspense>
        <Overview />
      </Suspense>
      {pendingArrival !== undefined && (
        <TemplateArrival
          templateCreated={pendingArrival}
          onHandled={clearArrival}
        />
      )}
    </>
  );
};
